import React, { useEffect, useState } from "react"
import Check from "../../assets/icons/circle-check.svg"
import { Box, Grid, Tab, Typography } from "@mui/material"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import CustomImage from "../../components/custom-image/custom-image.component"
import Tick from "../../assets/icons/tick-solutions.svg"
import Map from "../../assets/map.svg"
import * as S from "./SolutionsFeatures.styles"
import gsap from "gsap"
import { getRandom, getRandomInt } from "../../utils/utils"
const SolutionsFeatures = ({ title, description, features }) => {
  const [value, setValue] = useState("0")

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  useEffect(() => {
    if (value === "2") {
      const tl = gsap.timeline({ repeat: -1 })
      const aux = Array.from({ length: 27 }, (_, index) => index)
      aux.forEach((dot, index) => {
        const random = getRandom(0, 5)
        tl.fromTo(
          `#dot${index}`,
          { fillOpacity: 0 },
          {
            fillOpacity: 0.3,
            duration: 1,
            repeat: 1,
            yoyo: true,
            delay: random,
          },
          0,
        )
      })
    }
  }, [value])
  return (
    <S.Section>
      <S.Wrapper>
        <S.TopContainer>
          <S.Title>{title}</S.Title>
          <S.Description>{description}</S.Description>
          <S.CheckContainer>
            <Check />
            <Typography>Subscriber Benefits</Typography>
          </S.CheckContainer>
        </S.TopContainer>
        <S.TabsContainer>
          <TabContext value={value}>
            <S.TabListContainer>
              <Box>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  {features?.map(({ title, icon }, index) => (
                    <Tab
                      icon={<CustomImage img={icon} />}
                      label={title}
                      value={`${index}`}
                      key={`${index}-${title}`}
                    />
                  ))}
                </TabList>
              </Box>
            </S.TabListContainer>
            {features?.map(
              ({ title, details, image, notificationImage }, index) => (
                <TabPanel value={`${index}`} key={`${index}-${title}`}>
                  <S.FeatureDescriptionContainer>
                    <Grid container spacing={5} alignItems="center">
                      <Grid item xs={12} md={5}>
                        {details?.map(({ title, description }, index) => (
                          <S.Feature key={`${title}-${index}`}>
                            <S.SvgContainer>
                              <Tick />
                            </S.SvgContainer>
                            <S.InfoContainer>
                              <S.FeatureTitle>{title}</S.FeatureTitle>
                              <S.FeatureDescription>
                                {description}
                              </S.FeatureDescription>
                            </S.InfoContainer>
                          </S.Feature>
                        ))}
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <S.ImageContainer className={title.toLowerCase()}>
                          <S.Image
                            img={image}
                            className={title.toLowerCase()}
                          />
                          {title === "Easy" && (
                            <S.Image
                              img={notificationImage}
                              className="notification"
                            />
                          )}
                          {title === "Reliable" && <Map />}
                        </S.ImageContainer>
                      </Grid>
                    </Grid>
                  </S.FeatureDescriptionContainer>
                </TabPanel>
              ),
            )}
          </TabContext>
        </S.TabsContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default SolutionsFeatures
